import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import Heading from 'components/Heading';
import Icon from 'components/Icon';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { Modal } from 'apps/modals/views/modal';
import { Form } from 'libs/forms';

import { ModalContent } from 'apps/modals/styles';
import {
  FooterWrapper,
  WarningWrapper,
  IconWrapper,
} from 'apps/modals/fork/fork.styles';

@withNamespaces()
@observer
export default class ForkFormModal extends Modal {
  render() {
    const { projectManager } = this.props;

    return (
      <>
        <ModalTitle>
          <Trans>Select workspace</Trans>
        </ModalTitle>
        <ModalContent>
          <Form
            noBorder
            padding='0'
            formStore={projectManager.forkForm}
            formTitle=''
            buttonHandler={projectManager.Fork}
          />
          <FooterWrapper>
            <WarningWrapper>
              <IconWrapper>
                <Icon name='warning' />
              </IconWrapper>
              <Heading level={6} size='xsmall' weight='regular'>
                <Trans>Please note: we don’t support merging yet.</Trans>
              </Heading>
            </WarningWrapper>
          </FooterWrapper>
        </ModalContent>
      </>
    );
  }
}
